import { render, staticRenderFns } from "./ExchangeContact.vue?vue&type=template&id=e3f726fc&"
import script from "./ExchangeContact.vue?vue&type=script&lang=ts&"
export * from "./ExchangeContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports